import React from 'react'

const SectionSubtitle = ({ text }) => (
  <p className="f8 f7-m f6-l lh-title mv0">{text}</p>
)

export default SectionSubtitle
